import { Banner, Button, ColumnDefinition, ComboBox, Icon, Table, TextInput, } from '@abb/common-ux';
import * as ActionCreators from '@module/license/actionCreators/hardwareActionCreators';
import { IField, IServer, IServiceInstance, Server } from '@module/license/models';
import { API_ERROR_MESSAGE, API_SUPPORT_EMAIL, API_SUPPORT_MAILTO } from '@service/constants';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Option } from 'react-select';
import { default as ServerTable } from './HardwareTable';

/* tslint:disable:jsx-no-lambda jsx-no-multiline-js jsx-self-close*/
export class ServerTableContainer extends React.Component<any, any> {
  render() {
    const ServerTableColumn = ColumnDefinition as new () => ColumnDefinition<any>;
    const canAddHardware = !this.props.hardwareIsEditing;
    const errorMessage =
      <div hidden={!this.props.serverErrorMessageVisible}><Banner bannerType='error' id='errorBanner' onRemove={banner => { this.props.clearErrorMessage(); }}>
        {API_ERROR_MESSAGE}
        <a href={API_SUPPORT_MAILTO}>{API_SUPPORT_EMAIL}</a>
      </Banner></div>;

    const button = (<div className='col-md-4 text-right button-top-buffer'>
      <Button buttonType='normal' buttonSize='default' icon='plus' disabled={!canAddHardware} onClick={() => { this.props.AddNewEditableRow(new Server(), this.props.match.params.siteId); }}>Add Hardware</Button>
    </div>);

    return (
      <div className='container container-style'>
        <div className='row bottom-buffer'>
          <div className='col-md-8'>
            <h3>Hardware</h3>
          </div>
          {button}
        </div>
        {errorMessage}
        <div className='bs'>
          <div className='row'>
            <div className='col-md-12'>
              <ServerTable {...this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ServerTableContainer) as any);

export function mapStateToProps(store: { serverState: any; userState: { loggedInUser: { access_token: string } }; permissionsState: any }) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.serverState, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    AddNewEditableRow: (server: IServer[], siteId: number) => dispatch(ActionCreators.onAddNewEditableRow(server, siteId)),
    EditExistingRow: (server: IServer) => {
      dispatch(ActionCreators.onEditExistingRow(server));
    },
    ServerCancelEdit: (server: IServer) => dispatch(ActionCreators.onServerCancelEdit(server)),
    authenticatedUpdateServer: (server: IServer, accessToken: string) => {
      if (server.description.valid && server.serverId.valid) {
        dispatch(ActionCreators.onUpdateServer(server, accessToken));
      }
      // TODO: else statement
    },
    ServerDescriptionEdit: (updatedDescription: string) => {
      dispatch(ActionCreators.onServerDescriptionEdit(updatedDescription));
    },
    ServerServerIdEdit: (updatedServerId: string) => {
      dispatch(ActionCreators.onServerServerIdEdit(updatedServerId.toUpperCase()));
    },
    ServerOperationUseChange: (value: Option) => {
      dispatch(ActionCreators.onServerOperationalUseChange(value));
    },
    authenticatedDeleteServer: (server: IServer, accessToken: string) => dispatch(ActionCreators.onDeleteServer(server, accessToken)),
    clearErrorMessage: () => dispatch(ActionCreators.clearErrorMessage())
  };
}

function mergeProps({ accessToken, ...propsFromState }: any, { authenticatedUpdateServer, authenticatedDeleteServer, AddNewEditableRow, ServerCancelEdit, EditExistingRow, ServerDescriptionEdit, ServerServerIdEdit, ServerOperationUseChange, clearErrorMessage, ...propsFromDispatch }: any, ownProps: any) {
  const UpdateServer = (server: IServer) => authenticatedUpdateServer(server, accessToken);
  const DeleteServer = (server: IServer) => authenticatedDeleteServer(server, accessToken);
  return {
    ...propsFromState,
    ...ownProps,
    UpdateServer,
    DeleteServer,
    AddNewEditableRow,
    ServerCancelEdit,
    ServerDescriptionEdit,
    ServerServerIdEdit,
    ServerOperationUseChange,
    EditExistingRow,
    clearErrorMessage
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/Hardware/HardwareTableContainer.tsx